import React from 'react';
import PropTypes from 'prop-types';
import { sortByString } from '../../../utilities/string';
import { sortByDate } from '../../../utilities/time';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

class DocumentViewerHeader extends React.Component {
    render() {
        const { ascending, property, sortDocuments, includeSignature } = this.props;

        return (
            <div className="col-xs-12">
                <div className="col-xs-12 document-viewer-header no-select">
                    <div className={`col-sm-${includeSignature ? 4 : 5} col-xs-12 column name`} onClick={() => sortDocuments('display_name', sortByString)}>
                        <span className="ellipsis">
                            <FormattedMessage id={'document'} defaultMessage={'Document'} />
                        </span>
                        {property === 'display_name' && <i className="material-icons">{ascending ? 'arrow_upward' : 'arrow_downward'}</i>}
                    </div>

                    <div className={`col-sm-${includeSignature ? 2 : 3} hidden-xs column`} onClick={() => sortDocuments('ref_id', sortByString)}>
                        <span className="ellipsis">
                            <FormattedMessage id={'owner'} defaultMessage={'Owner'} />
                        </span>
                        {property === 'ref_id' && <i className="material-icons">{ascending ? 'arrow_upward' : 'arrow_downward'}</i>}
                    </div>
                    {includeSignature && (
                        <div className="col-sm-2 hidden-xs column">
                            <span className="ellipsis">
                                <FormattedMessage {...messages.signatureDate} />
                            </span>
                        </div>
                    )}

                    <div className="col-sm-2 hidden-xs column" onClick={() => sortDocuments('updated_at', sortByDate)}>
                        <span className="ellipsis">
                            <FormattedMessage id={'uploadDate'} defaultMessage={'Upload Date'} />
                        </span>
                        {property === 'updated_at' && <i className="material-icons">{ascending ? 'arrow_upward' : 'arrow_downward'}</i>}
                    </div>
                </div>
            </div>
        );
    }
}
DocumentViewerHeader.defaultProps = {
    ascending: undefined,
    property: undefined,
    sortDocuments: () => null,
    includeSignature: false
};
DocumentViewerHeader.propTypes = {
    ascending: PropTypes.any.isRequired,
    property: PropTypes.string.isRequired,
    sortDocuments: PropTypes.func.isRequired,
    includeSignature: PropTypes.bool
};

export default DocumentViewerHeader;



// WEBPACK FOOTER //
// ./src/components/document/viewer/header.jsx